import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import CouponsTable from './CouponsTable';

const Coupons = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Coupons' parent='Coupons'  />
      <Container fluid={true}>
        <Row>
          <CouponsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Coupons;
